import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=0bbde5b5&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbde5b5",
  null
  
)

export default component.exports